import DeleteAccountForm from "../components/DeleteAccountForm/DeleteAccountForm";
import Heading from "../components/Heading/Heading";
import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import useNavigation from "../hooks/navigation";
import useTranslation from "../hooks/useTranslation";

import style from "./AccountDeletionPage.module.css";

const AccountDeletionPage = () => {
  const navigation = useNavigation();
  const { t, m } = useTranslation();
  return (
    <UnderMaintenanceOrChildren>
      <div className={style.container}>
        <div className={style.formContainer}>
          <Heading type="h1">{t(m.AccountDeletion.AreYouSure)}</Heading>
          <DeleteAccountForm
            onCancel={() => {
              navigation.goToProfile();
            }}
          ></DeleteAccountForm>
        </div>
      </div>
    </UnderMaintenanceOrChildren>
  );
};

export default AccountDeletionPage;
